/**
 * @file: sleep.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { delayed } from './delay';

export async function sleep(ms: number): Promise<void> {
  await new Promise<void>(resolve => delayed(() => resolve(), ms));
}
